const scrollToTop = () => {
  window.scrollTo({top: 0, behavior: 'smooth'}); // Scroll to the top of the page smoothly
}

export default function Footer({EXTERNAL_LINKS}) {
  return (
    <footer>
      <div className="footerContent">
        <div className="information">
          <li><a className="navbar-link" href={EXTERNAL_LINKS.Discord} target="_blank">Contact us</a></li>
          <li><a className="navbar-link" onClick={scrollToTop}>Back to top</a></li>
        </div>
        <div className="copyright">
          <p>
            Copyright © 2019–{new Date().getFullYear()} CommandPanels. Not approved by or associated with Mojang or Microsoft.
          </p>
        </div>
      </div>
    </footer>
  )
}
